//#region IMPORTS
import { InstoreOrderLineTableRow } from "../../models/instoreOrder";
import { useVirtualizer } from "@tanstack/react-virtual";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { Row, Table } from "@tanstack/react-table";
import { RefObject } from "react";
import InstoreOrderDetailTableBodyRow from "./InstoreOrderDetailTableBodyRow";
//#endregion

interface Props {
  tableContainerRef: RefObject<HTMLDivElement>;
  moveRow?: (toIndex: number, row: InstoreOrderLineTableRow) => void;
  table: Table<InstoreOrderLineTableRow>;
}

export default function InstoreOrderDetailTableBody({
  tableContainerRef,
  moveRow,
  table,
}: Props) {
  //#region SETUP
  const { rows } = table.getRowModel();

  const rowVirtualizer = useVirtualizer<HTMLDivElement, HTMLTableRowElement>({
    getScrollElement: () => tableContainerRef.current,
    estimateSize: () => 40,
    count: rows.length,
    overscan: 5,
  });
  //#endregion

  return (
    <DndProvider backend={HTML5Backend}>
      <tbody
        className="bg-white relative"
        style={{
          height: `${rowVirtualizer.getTotalSize()}px`,
        }}
      >
        {rowVirtualizer.getVirtualItems().map((virtualRow) => {
          const row = rows[virtualRow.index] as Row<InstoreOrderLineTableRow>;
          return (
            <InstoreOrderDetailTableBodyRow
              virtualRow={virtualRow}
              moveRow={moveRow}
              key={row.id}
              row={row}
            />
          );
        })}
      </tbody>
    </DndProvider>
  );
}
